import type { ReactNode } from 'react';

/**
 * Local line icons (stroke = currentColor). The Figma file's own icon assets could not be downloaded in this environment (asset URLs are blocked), so these
 * are drawn to the same 24-grid / 1.5-2px stroke style as the design's Phosphor-style icons; none is an emoji or a remote image.
 */
function Svg({ children, size = 18 }: { children: ReactNode; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      {children}
    </svg>
  );
}

export const EyeIcon = () => <Svg><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" /><circle cx="12" cy="12" r="2.8" /></Svg>;
export const DownloadIcon = () => <Svg><path d="M12 4v11M7.5 10.8 12 15.3l4.5-4.5M5 19.5h14" /></Svg>;
export const PrintIcon = () => <Svg><path d="M7 9V4h10v5M7 17H5v-7h14v7h-2M7 14h10v6H7z" /></Svg>;
export const PaidIcon = () => <Svg><circle cx="12" cy="12" r="8.5" /><path d="m8.3 12.3 2.6 2.6 4.9-5.3" /></Svg>;
export const VoidIcon = () => <Svg><path d="M6 3.5h12v17l-3-2-3 2-3-2-3 2zM9.5 8.5l5 5M14.5 8.5l-5 5" /></Svg>;
export const MailIcon = () => <Svg><rect x="3" y="5.5" width="18" height="13" rx="2" /><path d="m3.8 7 8.2 6.2L20.2 7" /></Svg>;
export const ExportIcon = () => <Svg><path d="M12 15V4.5M8 8.2l4-3.9 4 3.9M5 13v6.5h14V13" /></Svg>;
export const PlusIcon = () => <Svg><path d="M12 5v14M5 12h14" /></Svg>;
export const CaretDownIcon = () => <Svg size={16}><path d="m6 9.5 6 6 6-6" /></Svg>;
export const CalendarIcon = () => <Svg size={20}><rect x="3.5" y="5" width="17" height="15" rx="2" /><path d="M3.5 10h17M8 3.5v3M16 3.5v3" /></Svg>;
export const UploadIcon = () => <Svg size={22}><rect x="3.5" y="4.5" width="17" height="15" rx="2" /><circle cx="9" cy="10" r="1.6" /><path d="m4 17 5-4.5 4 3.5 3-2.5 4 3.5" /></Svg>;
export const FileIcon = () => <Svg size={16}><path d="M6.5 3.5h7l4 4v13h-11z" /><path d="M13.5 3.5v4h4" /></Svg>;
export const TrashIcon = () => <Svg size={16}><path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6" /></Svg>;
export const CloseIcon = () => <Svg size={20}><path d="m6 6 12 12M18 6 6 18" /></Svg>;
export const WalletIcon = () => <Svg size={22}><rect x="3" y="6" width="18" height="13" rx="2.5" /><path d="M3 10h18M16.5 14.5h.5" /></Svg>;
export const UsersIcon = () => <Svg size={22}><circle cx="9" cy="8.5" r="3.2" /><path d="M3 19c.6-3.4 3-5 6-5s5.4 1.6 6 5" /><path d="M16 6a3 3 0 0 1 0 5.4M17.5 14.2c2 .5 3.2 2 3.5 4.8" /></Svg>;
export const WarnIcon = () => <Svg size={22}><path d="M12 4 3 19.5h18z" /><path d="M12 10v4.2M12 16.8v.1" /></Svg>;
export const XCircleIcon = () => <Svg size={22}><circle cx="12" cy="12" r="8.5" /><path d="m9 9 6 6M15 9l-6 6" /></Svg>;
export const InfoIcon = () => <Svg size={14}><circle cx="12" cy="12" r="8.5" /><path d="M12 11v5M12 8v.1" /></Svg>;
export const FolderOpenIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true" focusable="false">
    <path d="M4 10a2 2 0 0 1 2-2h9l3 4h16a2 2 0 0 1 2 2v3H9.2a2 2 0 0 0-1.9 1.4L4 27z" fill="currentColor" opacity="0.55" />
    <path d="M7.3 18.4A2 2 0 0 1 9.2 17H37a2 2 0 0 1 1.9 2.6l-3 12A2 2 0 0 1 34 33H6a2 2 0 0 1-1.9-2.6z" fill="currentColor" />
  </svg>
);
export const SortIcon = ({ direction }: { direction: 'ascending' | 'descending' | 'none' }) => (
  <svg width="10" height="12" viewBox="0 0 10 12" aria-hidden="true" focusable="false" data-direction={direction}>
    {direction !== 'descending' && <path d="M5 1 8.5 5h-7z" fill="currentColor" />}
    {direction !== 'ascending' && <path d="M5 11 1.5 7h7z" fill="currentColor" />}
  </svg>
);
